export default __webpack_public_path__ + "static/143-c0f48551cb7df00bf1cd3ff43b223eac.gif";